var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.3776C4 17.9593 7.58172 14.3776 12 14.3776C16.4183 14.3776 20 17.9593 20 22.3776H18C18 19.0639 15.3137 16.3776 12 16.3776C8.68629 16.3776 6 19.0639 6 22.3776H4ZM12 13.3776C8.685 13.3776 6 10.6926 6 7.37762C6 4.06262 8.685 1.37762 12 1.37762C15.315 1.37762 18 4.06262 18 7.37762C18 10.6926 15.315 13.3776 12 13.3776ZM12 11.3776C14.21 11.3776 16 9.58762 16 7.37762C16 5.16762 14.21 3.37762 12 3.37762C9.79 3.37762 8 5.16762 8 7.37762C8 9.58762 9.79 11.3776 12 11.3776Z",
    fill: "#1A1645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.fb725b193d4caf2e51980c3141c9ae92.svg";
export { ForwardRef as ReactComponent };